<template>
<div class="form">
  <v-card style="margin-top: 250px">
        <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
        <h1 align="center" style="text-decoration: underline overline;">JRF - SEKSYEN 3 : PERUMAHAN</h1>

        <v-text-field
          outlined 
          dense
          rounded
          v-model="HID"
          label="HID"
          width="20px"
          disabled
        ></v-text-field>

      <!-- DATATABLE  -->
      <v-card  color="rgba(217, 217, 217, 0.5)" class="mb-5">
            <v-card-title>
                Senarai
              <v-spacer></v-spacer>
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
              ></v-text-field>
            </v-card-title>
            <v-data-table
              :headers="headers"
              :items="dataJRF3"
              :search="search"
              class="ml-3 mr-3"
              @click:row="handleClick"
            >
            <template v-slot:item.HR= "{ item }">
            {{ formatNumber(item.HR) }}
          </template>
            </v-data-table>
      </v-card>   
    </v-card>   


<v-card>
  <span style="color:red;font-weight:bold;font-size: small;"><v-col> Medan yang bertanda * wajib diisi</v-col></span>
  <v-card-title>
   SEKSYEN 3 : PERUMAHAN
  </v-card-title>
  <v-card-text>
    <v-form
      ref="form"
      v-model="valid"
      lazy-validation
    > 
 <v-container>
    <v-col class="black--text">
          <v-row>
            S.1  Apakah jenis tempat kediaman yang anda tinggal sekarang?  <strong>[JR]</strong><br><span style="color:red;font-weight:bold;font-size: small;"> * </span>
          </v-row>
        </v-col>
      <v-row >
            <v-col cols="6" sm="6" md="4" class="black--text">
               <v-autocomplete
                  :items="JenisRumah"
                  :item-text="item => item.id + ' - ' + item.desc"
                  label=""
                  return-object
                  outlined
                  dense
                  style="width: 350px"
                  v-model="JRR"
                ></v-autocomplete>
                  <!-- <v-text-field
                    v-model="JR"           
                    outlined
                    :items="JenisRumah"
                    item-text="desc"    
                    return-object
                    label = ""
                    required
                    dense
                    readonly--- tambah kat atas 28/1/2022
                    style="width:350px;"
                    :disabled="true"
                    @keypress="isNumber($event)"
                  ></v-text-field> -->
                </v-col>
              </v-row>
           
          </v-container>

          <!-- S158 -->
          <v-col v-show="showS158" class="black--text">
            <v-row>
                S.1 (a) Sila nyatakan jenis tempat kediaman anda
            </v-row>
            <!-- <v-container> -->
              <v-row >
                <v-col cols="6" sm="6" md="4" class="black--text">
                  <v-text-field
                    v-model="JRLain"
                    persistent-hint
                    outlined
                     label = "0"
                    solo
                    required
                    dense
                    style="width:350px;"
                  ></v-text-field>
                </v-col>
              </v-row>
            <!-- </v-container> -->
          </v-col>
    <!-- S159 -->
    <div v-show="showBorang">
          <v-row>
            <v-col class="black--text">
              S.2  Apakah status pemilikan tempat kediaman yang anda tinggal
              sekarang  <strong>[JMR] </strong> <span style="color:red;font-weight:bold;font-size: small;"> * </span><br>
            </v-col>
          </v-row>
          <v-container>
            <v-row>
              <v-col class="black--text" cols="4" sm="4" md="4">
                <v-autocomplete
                  :items="JenisMilikanRumah"
                  :item-text="item => item.id + ' - ' + item.desc"
                  label=""
                  return-object
                  solo
                  outlined
                  required
                  dense
                  style="width: 350px"
                  v-model="JMR"
                ></v-autocomplete>
              </v-col>
            </v-row>
          </v-container>
  <!-- S160 -->
     <v-col v-show="showS160" class="black--text">
          <v-row>
              S.2 (a) Sila nyatakan status pemilikan tempat kediaman anda
          </v-row>
          <!-- <v-container> -->
            <v-row class="black--text">
              <v-col cols="6" sm="6" md="4">
                <v-text-field
                  v-model="JMRLain"
                  persistent-hint
                  required   
                  solo               
                  outlined
                  dense
                  style="width: 350px"
                ></v-text-field>
              </v-col>
            </v-row>
          <!-- </v-container> -->
        </v-col>
  <!-- S161 -->
        <v-col class="black--text">
          <v-row>
            S.3 Adakah ahli isi rumah anda memiliki tempat kediaman lain <strong> [PL]</strong> <span style="color:red;font-weight:bold;font-size: small;"> * </span><br/>
          </v-row>
          </v-col>
          <v-container>
            <v-autocomplete 
              :items="yaTidak"
              :item-text="item => item.id + ' - ' + item.desc"
              label=""
              return-object
              required
              solo
              outlined
              dense
              style="width: 350px"
              v-model="PL"
            ></v-autocomplete>
          </v-container>

  <!-- S162 -->
          <v-row>
            <v-col class="black--text">
              S.4  Nyatakan berapakah jumlah anggaran harga semasa bagi semua
              TK yang dimiliki <strong>[HR] </strong>
          
          <v-container>
            <v-row class="black--text">
              <v-col cols="6" sm="6" md="4">
                <v-text-field
                  v-model="HR"
                  min="0"
                  maxlength="8"
                  label="RM"
                  type="number"
                  persistent-hint
                  solo
                  outlined
                  dense
                  style="width: 350px"
                  @keypress="limitDigits"
                  
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container> 
  <!-- S163 -->
          <v-row>
            <v-col class="black--text">
              S.5  Adakah pinjaman perumahan telah diselesaikan? <strong>[PR]</strong>
            </v-col>
          </v-row>
          <v-container>
            <v-autocomplete
              :items="yaTidakBerkenaan"
              :item-text="item => item.id + ' - ' + item.desc"
              label=""
              return-object
              solo
              outlined
              dense
              style="width: 350px"
              v-model="PR"
            ></v-autocomplete>
          </v-container>

   <!-- S163Catatan -->
          <v-col v-show="showS163C" class="black--text">
            <v-row>
                S.5C Catatan jika tidak berkenaan.
            </v-row>
            <!-- <v-container> -->
              <v-row >
                <v-col cols="6" sm="6" md="4" class="black--text">
                  <v-text-field
                    v-model="PRCatatan"
                    persistent-hint
                    outlined
                     label = "0"
                    solo
                    required
                    dense
                    style="width:450px;"
                  ></v-text-field>
                </v-col>
              </v-row>
            <!-- </v-container> -->
          </v-col></v-col></v-row>

  <!-- S164 -->
          <v-row>
            <v-col class="black--text">
              S.6  Nyatakan bilangan bilik tidur di tempat kediaman anda
              sekarang <strong>[BT]</strong><span style="color:red;font-weight:bold;font-size: small;"> * </span><br />
            </v-col>
          </v-row>
          <v-container>
            <v-row class="black--text">
              <v-col cols="6" sm="6" md="4">
                <v-text-field
                  v-model="BT"
                  persistent-hint
                  required
                  outlined
                  solo
                  dense
                  style="width: 350px"
                  type="number"
                  @keypress="limitDigits2"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>

  <!-- S165 -->
          <v-row>
            <v-col class="black--text">
              S.7  Bagaimanakah keadaan tempat kediaman anda sekarang? <strong> [KR]</strong><span style="color:red;font-weight:bold;font-size: small;"> * </span><br />
            </v-col>
          </v-row>
          <v-container>
            <v-autocomplete
              :items="KisahRumah"
              :item-text="item => item.id + ' - ' + item.desc"
              label=""
              return-object
              required
              solo
              outlined
              dense
              style="width: 350px"
              v-model="KR"
            ></v-autocomplete>
          </v-container>
  
  <!-- S166 -->
          <v-row>
            <v-col class="black--text">
              S.8  Apakah bahan binaan dinding luar tempat kediaman anda
              sekarang? <strong>[BDR] </strong><span style="color:red;font-weight:bold;font-size: small;"> * </span><br />
            </v-col>
          </v-row>
          <v-container>
            <v-autocomplete
              :items="BinaanDindingRumah"
              :item-text="item => item.id + ' - ' + item.desc"
              label=""
              return-object
              required
              solo
              outlined
              dense
              style="width: 350px"
              v-model="BDR"
            ></v-autocomplete>
          </v-container>

    <!-- S167 -->
        <v-col v-show="showS167" class="black--text">
          <v-row>
              S.8 (a) Sila nyatakan bahan binaan dinding luar tempat kediaman
              anda<strong>[BDRLain]</strong><br />
          </v-row>
          <!-- <v-container> -->
            <v-row class="black--text">
              <v-col cols="6" sm="6" md="4">
                <v-text-field
                  v-model="BDRLain"
                  persistent-hint
                  required
                  solo
                  outlined
                  dense
                  style="width: 350px"
                ></v-text-field>
              </v-col>
            </v-row>
          <!-- </v-container> -->
        </v-col>

<!-- S168 -->
          <v-row>
            <v-col class="black--text">
              S.9  Apakah jenis kemudahan tandas di tempat kediaman anda
              sekarang? <strong>[JT]</strong><span style="color:red;font-weight:bold;font-size: small;"> * </span><br />
            </v-col>
          </v-row>
          <v-container>
            <v-select
              :items="JenisTandas"
              :item-text="item => item.id + ' - ' + item.desc"
              label=""
              required
              return-object
              solo
              outlined
              dense
              style="width: 350px"
              v-model="JT"
            ></v-select>
          </v-container>

  <!-- S169 -->
        <v-col v-show="showS169" class="black--text">
          <v-row>
            S.9 (a) Sila nyatakan jenis kemudahan tandas di tempat kediaman anda <strong>[JTLain]</strong>
              <br />
          </v-row>
          <!-- <v-container> -->
            <v-row class="black--text">
              <v-col cols="6" sm="6" md="4">
                <v-text-field
                  v-model="JTLain"
                  persistent-hint
                  outlined
                  solo
                  required
                  dense
                  style="width: 350px"
                ></v-text-field>
              </v-col>
            </v-row>
          <!-- </v-container> -->
        </v-col>
  <!-- S170 -->
          <v-row>
            <v-col class="black--text">
              S.10  Apakah jenis kemudahan bekalan air di tempat kediaman anda
              sekarang? <strong>[BA]</strong><span style="color:red;font-weight:bold;font-size: small;"> * </span><br />
            </v-col>
          </v-row>
          <v-container>
            <v-autocomplete
              :items="BekalanAir"
              :item-text="item => item.id + ' - ' + item.desc"
              label=""
              return-object
              solo
              required
              outlined
              dense
              style="width: 350px"
              v-model="BA"
            ></v-autocomplete>
          </v-container>
   <!-- S171 -->
        <v-col v-show="showS171">
          <v-row>
            <v-col class="black--text">
              S.10 (a) Sila nyatakan kemudahan bekalan air di tempat kediaman
              anda<strong></strong><br />
            </v-col>
          </v-row>
          <!-- <v-container> -->
            <v-row class="black--text">
              <v-col cols="6" sm="6" md="4">
                <v-text-field
                  v-model="BALain"
                  persistent-hint
                  required
                  outlined
                  solo
                  dense
                  style="width: 350px"
                ></v-text-field>
              </v-col>
            </v-row>
          <!-- </v-container> -->
        </v-col>

  <!-- S172 -->
  
          <v-row>
            <v-col class="black--text">
              S.11  Apakah kemudahan bekalan air minuman di tempat kediaman anda sekarang? 
               (Jawapan berganda diterima, tidak lebih dari 2 jawapan)<strong>[AM]</strong><span style="color:red;font-weight:bold;font-size: small;"> * </span><br />
            </v-col>            
        </v-row>
        <v-container class="black--text">
             <v-row>
              <v-col cols="4" sm="6" md="4">
                i. <strong>[AM1]</strong>
              <v-autocomplete
              :items="AirMinuman"
              :item-text="item => item.id + ' - ' + item.desc"
              label=""
              return-object
              required
              solo
              outlined
              dense
              style="width: 350px"
              v-model="AM"
              @change="S172_AM1()"
            ></v-autocomplete>           
              </v-col>

              <v-col cols="4" sm="6" md="4">
                ii. <strong>[AM2]</strong>
              <v-autocomplete
              :items="AirMinuman"
              :item-text="item => item.id + ' - ' + item.desc"
              label=""
              return-object
              required
              solo
              outlined
              dense
              style="width: 350px"
              v-model="AM2"
              @change="S172_AM2()"
              ></v-autocomplete>           
              </v-col>
         </v-row>
        </v-container>


  <!-- S173 -->
        <v-col v-show="showS173A" class="black--text">
          <v-row>
            <!-- <v-col > -->
              S.11 (a) Sila nyatakan kemudahan bekalan air minum di tempat kediaman anda<strong>[AMLain]</strong><br />
            <!-- </v-col> -->
          </v-row>
          <!-- <v-container> -->
            <v-row class="black--text">
              <v-col cols="6" sm="6" md="4">
                <v-text-field
                  v-model="AMLain"
                  persistent-hint
                  label="0"
                  solo
                  outlined
                  dense
                  style="width: 350px"
                ></v-text-field>
              </v-col>
            </v-row>
          <!-- </v-container> -->
        </v-col>
        <v-col v-show="showS173B" class="black--text">
          <v-row>
            <!-- <v-col > -->
              S.11 (a) Sila nyatakan kemudahan bekalan air minum di tempat kediaman anda<strong>[AMLain]</strong><br />
            <!-- </v-col> -->
          </v-row>
          <!-- <v-container> -->
            <v-row class="black--text">
              <v-col cols="6" sm="6" md="4">
                <v-text-field
                  v-model="AMLain"
                  persistent-hint
                  label="0"
                  solo
                  outlined
                  dense
                  style="width: 350px"
                ></v-text-field>
              </v-col>
            </v-row>
          <!-- </v-container> -->
        </v-col>

  <!-- S174 -->
          <v-row>
            <v-col class="black--text">
              S.12  Apakah kemudahan bekalan elektrik di tempat kediaman anda sekarang? <strong>[BE]</strong><span style="color:red;font-weight:bold;font-size: small;"> * </span><br />
            </v-col>
          </v-row>
          <v-container>
            <v-autocomplete
              :items="BekalanElektrik"
              :item-text="item => item.id + ' - ' + item.desc"
              label=""
              return-object
              required
              solo
              outlined
              dense
              style="width: 350px"
              v-model="BE"
            ></v-autocomplete>
          </v-container>

                    <!-- S175 -->
  <!-- <v-col class="black--text">
          <v-row>
            
              S175 . Infrastruktur rangkaian yang terdapat di rumah/kawasan ini<strong>[RRK]</strong><br />
            
          </v-row>
            <v-row class="black--text">
              <v-col cols="8" sm="12" md="6">
                <v-autocomplete
                :items="Rangkaian"
                :item-text="item => item.id + ' - ' + item.desc"
                  v-model="RRK"
                  label=""
                  solo
                  return-object
                  outlined
                  required
                  dense
                ></v-autocomplete>
              </v-col>
             </v-row>
        </v-col> -->

        <v-row>
            <v-col  class="black--text">
              S.13  Adakah terdapat capaian internet berikut di rumah anda ? <br />
            </v-col>
          </v-row>
        
          <v-container class="black--text">
            <v-row>
              <v-col cols="4" sm="6" md="4">
                i. Sambungan Internet talian tetap <strong>[ITT]</strong><span style="color:red;font-weight:bold;font-size: small;"> * </span>
                <v-autocomplete
                  :items="yaTidak"
                  :item-text="item => item.id + ' - ' + item.desc"
                  item-value="id"
                  label=""
                  return-object
                  required
                  solo
                  outlined
                  dense
                  style="width:350px;"
                  v-model="ITT"
                  min="1"
                  max="3"
                ></v-autocomplete>
              </v-col>

              <v-col cols="4" sm="6" md="4">
              ii. Sambungan Internet mudah alih <strong>[ITM]</strong><span style="color:red;font-weight:bold;font-size: small;"> * </span>
                <v-autocomplete
                  :items="yaTidak"
                  :item-text="item => item.id + ' - ' + item.desc"
                  item-value="id"
                  label=""
                  return-object
                  required
                  solo
                  outlined
                  dense
                  style="width:350px;"
                  v-model="ITM"
                  min="1"
                  max="3"
                ></v-autocomplete>
              </v-col>
            </v-row>
          </v-container>

            <v-row>
            <v-col  class="black--text">
              S.14  Adakah jaringan Internet komuniti disediakan di kawasan anda ? <strong>[ITK]</strong><span style="color:red;font-weight:bold;font-size: small;"> * </span>
            <v-container>
              <v-autocomplete
              :items="yaTidak"
              :item-text="item => item.id + ' - ' + item.desc"
              label=""
              return-object
              required
              solo
              outlined
              dense
              style="width: 350px"
              v-model="ITK"
            ></v-autocomplete> 
         </v-container> </v-col>
          </v-row>

          <v-row>
            <v-col class="black--text">
              S.15  Bagaimanakah anda melupuskan sisa pepejal di tempat kediaman
              anda? (Jawapan berganda diterima, tidak lebih dari 3 jawapan)<strong>[SP]</strong><span style="color:red;font-weight:bold;font-size: small;"> * </span><br />
            </v-col>            
        </v-row>
        <v-container class="black--text">
             <v-row>
              <v-col cols="4" sm="6" md="4">
                i. <strong>[SP1]</strong><span style="color:red;font-weight:bold;font-size: small;"> * </span><br />
              <v-autocomplete
              :items="SisaPepejal"
              :item-text="item => item.id + ' - ' + item.desc"
              label=""
              return-object
              required
              solo
              outlined
              dense
              style="width: 350px"
              v-model="SP1"
              @change="S175_SP1()"
              
            ></v-autocomplete>           
              </v-col>

              <v-col cols="4" sm="6" md="4">
                ii. <strong>[SP2]</strong><span style="color:red;font-weight:bold;font-size: small;"> * </span><br />
              <v-autocomplete
              :items="SisaPepejal"
              :item-text="item => item.id + ' - ' + item.desc"
              label=""
              return-object
              required
              solo
              outlined
              dense
              style="width: 350px"
              v-model="SP2"
              @change="S175_SP2()"
             
              ></v-autocomplete>           
              </v-col>
              
              <v-col cols="4" sm="6" md="4"> 
                iii. <strong>[SP3]</strong><span style="color:red;font-weight:bold;font-size: small;"> * </span><br />
              <v-autocomplete
              :items="SisaPepejal"
              :item-text="item => item.id + ' - ' + item.desc"
              label=""
              return-object
              required
              solo
              outlined
              dense
              style="width: 350px"
              v-model="SP3"
              @change="S175_SP3()"
              
              ></v-autocomplete> 
              </v-col>  
         </v-row>
        </v-container>
              
  <!-- S177 -->
   <v-col v-show="showS176A" class="black--text">
          <v-row>
            S.15 (a) Sila nyatakan cara anda melupuskan melupuskan sisa pepejal
              di tempat kediaman anda<strong>[SPLain]</strong><br />
          </v-row>
          <!-- <v-container> -->
            <v-row>
              <v-col cols="6" sm="6" md="4">
                <v-text-field
                  v-model="SPLain"
                  persistent-hint
                  label="0"
                  outlined
                  solo
                  dense
                  style="width: 350px"
                ></v-text-field>
              </v-col>
            </v-row>
          <!-- </v-container> -->
    </v-col>
    <v-col v-show="showS176B" class="black--text">
          <v-row>
            S.15 (a) Sila nyatakan cara anda melupuskan melupuskan sisa pepejal
              di tempat kediaman anda<strong>[SPLain]</strong><br />
          </v-row>
          <!-- <v-container> -->
            <v-row>
              <v-col cols="6" sm="6" md="4">
                <v-text-field
                  v-model="SPLain"
                  @change="S175_SPLain()"
                  persistent-hint
                  label="0"
                  outlined
                  solo
                  dense
                  style="width: 350px"
                ></v-text-field>
              </v-col>
            </v-row>
          <!-- </v-container> -->
    </v-col>
    <v-col v-show="showS176C" class="black--text">
          <v-row>
            S.15 (a) Sila nyatakan cara anda melupuskan melupuskan sisa pepejal
              di tempat kediaman anda<strong>[SPLain]</strong><br />
          </v-row>
          <!-- <v-container> -->
            <v-row>
              <v-col cols="6" sm="6" md="4">
                <v-text-field
                  v-model="SPLain"
                   @change="S175_SPLain()"
                  persistent-hint
                  label="0"
                  outlined
                  solo
                  dense
                  style="width: 350px"
                ></v-text-field>
              </v-col>
            </v-row>
          <!-- </v-container> -->
    </v-col>
  <!-- S178 -->
          <v-row>
            <v-col class="black--text">
              S.16  Adakah kemudahan kutipan sampah sampai ke tempat kediaman/kawasan anda? <strong>[KS]</strong><span style="color:red;font-weight:bold;font-size: small;"> * </span><br />
            </v-col>
          </v-row>
          <v-container>
            <v-autocomplete
              :items="KutipanSampah"
              :item-text="item => item.id + ' - ' + item.desc"
              label=""
              return-object
              required
              solo
              outlined
              dense
              style="width: 350px"
              v-model="KS"
            ></v-autocomplete>
          </v-container>

  <!-- S179 -->
    <v-col v-show="showS178" class="black--text">
       <v-row>
        S.17  Apakah tahap kepuasan anda berkenaan perkhidmatan kutipan sampah di tempat kediaman/kawasan anda? <strong>[TKS]</strong> <br />
        </v-row>
        <v-row>
          <v-col cols="4" sm="6" md="4">
            <v-autocomplete
              :items="TahapKutipanSampah"
              :item-text="item => item.id + ' - ' + item.desc"
              label=""
              return-object
              required
              solo
              outlined
              dense
              style="width: 350px"
              v-model="TKS"
              @change="S178()"
            ></v-autocomplete
            >
            </v-col>
            </v-row>
             </v-col>

  <!-- S180  -->
  <v-col v-show="showS179" class="black--text">
          <v-row>
            S.18  Apakah sebab anda tidak berpuas hati terhadap kutipan sampah? <strong>[SKS]</strong> <br />
          </v-row>
          <!-- <v-container> -->
             <v-row>
              <v-col cols="4" sm="6" md="4">
              <v-autocomplete
              :items="SebabKutipanSampah"
              :item-text="item => item.id + ' - ' + item.desc"
              label=""
              return-object
              required
              solo
              outlined
              dense
              style="width: 350px"
              v-model="SKS1"
              @change="S179_SKS1()"
            ></v-autocomplete>           
              </v-col>

         </v-row>
          <!-- </v-container> -->
        </v-col>

  <!-- S181 -->
  <v-col v-show="showS180" class="black--text">
          <v-row>
            
            S.18 (a) Sila nyatakan sebab lain-lain<br />
            
          </v-row>
          <!-- <v-container> -->
            <v-row class="black--text">
              <v-col cols="8" sm="12" md="6">
                <v-text-field
                  v-model="SKSLain"
                  persistent-hint
                  solo
                  outlined
                  dense
                ></v-text-field>
              </v-col>
             </v-row>
          <!-- </v-container> -->
          
        </v-col>

          
    </div>
        </v-form>
      </v-card-text>

 
<v-card-actions>
 <v-spacer></v-spacer>
    <v-btn
        text
        color="primary"
        @click='simpan()'
        v-show="butangSimpan"
         :disabled="!JRR || !JMR || !PL  || !KR || !BT || !BDR || !JT || !BA || !AM || !AM2 
        || !BE || !SP1 || !SP2 || !SP3 || !KS">
    
      Simpan
    </v-btn>
    <v-btn
      text
      color="primary"
      v-show="butangKemaskini"
      @click="kemaskiniJRF()"
    >
      Kemaskini
    </v-btn>
     <!-- <v-btn
      text
      color="primary"
      v-show="butangDelete"
      @click="deleteJRF()"
    >
      Padam
    </v-btn> -->
    <v-alert
      prominent
      type="error"
      :value="popUpALert"
    >
      <v-row align="center" class="mb-2">
        <v-col class="grow">
          Adakah anda pasti untuk padam?
        </v-col>
        <v-col class="shrink">
          <v-btn @click="padam('1')" class="mb-3">Confirm</v-btn>
          <v-btn @click="padam('2')">Cancel</v-btn>
        </v-col>
      </v-row>
    </v-alert>
</v-card-actions>
</v-card>
 

<!-- Error Dialog -->
<v-dialog
      v-model="errorDialog"
      width="500"
      height="200"
    >
    <v-card>
      <v-alert
        dense
        outlined
        color="#C51162"
        type="error"
      >
      <strong>{{errMessage}}</strong>
      </v-alert>
    </v-card>
</v-dialog>

<!-- Success Dialog -->
<v-dialog
      v-model="successDialog"
      width="500"
      height="200"
    >
    <v-card
    color="success"
    >
      <v-alert
        dense
        outlined
        color="#C51162"
        type="success"
      >
      <strong>{{successMessage}}</strong>
      </v-alert>
     <v-card-actions> 
        <v-spacer></v-spacer>
            <v-btn
                color="warning"
                @click='successDialog = false;'
            >
              Batal
            </v-btn>
            <v-btn
                color="pink"
                v-show="butangKemaskini"
                @click='successDialog = false;'
            >
              Kemaskini
            </v-btn>
            <v-btn
              color="primary"
              @click='goTo("2")'
            >
              Pengisian Seterusnya
            </v-btn>
      </v-card-actions>
    </v-card>
</v-dialog>


</div>
</template>
<script>
import axios from '../../plugins/axios'
//import schemeRule from '../../utils/scheme'
//////////////////////////import services///////////////////
import getLocalStorage from '@/services/getLocalStorage'
const localStorageData = new getLocalStorage(); 

import hidServices from "@/services/lookupField";
const lookup = new hidServices();

import lookupField from '@/services/lookupField'
const lookupFieldServices = new lookupField();
//////////////////////////end import services//////////////

export default {
    
    async beforeMount(){
        
        var dataHID = localStorageData.getHIDdata()

       this.HID = dataHID.HID;
        this.BNO = dataHID.BNO;
        this.Ps = dataHID.P;
        this.S = dataHID.S;
        this.NG = dataHID.NG;
        this.DP = dataHID.DP;
        this.DB =  dataHID.DB;
        this.BP = dataHID.BP;
        this.ST = dataHID.ST;
        this.NOTK = dataHID.NOTK;
        this.NOIR = dataHID.NOIR;
        this.Bulan = dataHID.BULAN;
        this.Tahun = dataHID.TAHUN;

        this.JenisRumah = lookupFieldServices.getJenisRumah();
        this.yaTidak = lookupFieldServices.getYaTidak();
        this.JenisMilikanRumah = lookupFieldServices.getJenisMilikanRumah();
        this.yaTidakBerkenaan = lookupFieldServices.getyaTidakBerkenaan();
        this.KisahRumah = lookupFieldServices.getKisahRumah();
        this.BinaanDindingRumah = lookupFieldServices.getBinaanDindingRumah();
        this.JenisTandas = lookupFieldServices.getJenisTandas();
        this.BekalanAir = lookupFieldServices.getBekalanAir();
        this.AirMinuman = lookupFieldServices.getAirMinuman();
        this.BekalanElektrik = lookupFieldServices.getBekalanElektrik();
        this.KutipanSampah = lookupFieldServices.getKutipanSampah();
        this.TahapKutipanSampah = lookupFieldServices.getTahapKutipanSampah();
        this.Kerap = lookupFieldServices.getKerap();
        this.SisaPepejal = lookupFieldServices.getSisaPepejal();
        this.SebabKutipanSampah = lookupFieldServices.getSebabKutipanSampah();
        this.Rangkaian = lookupFieldServices.getRangkaian();
       
        this.currNOAIRData = localStorageData.getCurrentNOAIRData();//dapatkan NOAIR yang di click dari page depan
        this.NOAIR = this.currNOAIRData.NOAIR;
        
        this.getData();//dapatkan data based on HID
        this.getDataINCS22_1();
    },

    computed: {
    //   dataJRF3() {
    //     return this.dataJRF3.map(item => ({
    //      ...item,
    //      HR: this.formatNumber(item.HR),
    //   }));
    //  },
    },
     
    data: () => ({
        showBorang: false,
        updateButton: true,
        saveButton: false,
        disabledInput: true,
        butangSimpan: true,
        butangSeterusnya: false,
        butangKemaskini: false,
        butangDelete: true,
        dialog: false,
        successDialog: false,
        errorDialog: false,
        successMessage:'',
        errMessage:'',
        message: "Saving Data",
        popUpALert:false,
        search: '',
        JenisRumah:[],
        JenisMilikRumah:[],
        yaTidakBerkenaan:[],
        KisahRumah:[],
        BinaanDindingRumah:[],
        JenisTandas:[],
        BekalanAir:[],
        BekalanElektrik:[],
        AirMinuman:[],
        KutipanSampah:[],
        TahapKutipanSampah:[],
        Kerap:[],
        SP8: false,
        SisaPepejal:[],
        SebabKutipanSampah:[],
        Rangkaian:[],
        yaTidak:[],
        currNOAIRData:'',
        /////////////////////data declaration//////////////////////////
        
        HID: '',
        JR:'',
        JRR:'',
        JRLain:0,
        JMR: '',
        JMRLain:0,
        PL: '',
        HR: '',
        PR: '',
        KR: '',
        BT: '',
        BDR: '',
        BDRLain:0,
        JT: '',
        JTLain:0,
        BA: '',
        BALain:0,
        AM:'',
        AM2:'',
        AMLain:'',
        BE:'',
        SP1:'', 
        SP2: '',
        SP3: '',    
        SPLain:'',
        KS: '',
        TKS:'',
        SKS1:'',
        SKS2: '',
        SKS3: '',
        ITT: '',
        ITM: '',
        ITK: '',
        SKSLain:0,
        //RRK:'',
        NOAIR:'',
        dataJRF3: [],
        rules: [
        value => !!value || 'Required.',
        ],

        headers: [
          {
            align: 'start',
            sortable: false,
          },
            { text: 'HID',value:'HID'},
            { text: 'JR',value:'JR'},
            { text: 'JRLain',value:'JRLain'},
            { text: 'JMR',value:'JMR'},
            { text: 'JMRLain',value:'JMRLain'},
            { text: 'PL',value:'PL'},
            { text: 'HR',value:'HR'},
            { text: 'PR',value:'PR'},
            { text: 'PRCatatan',value:'PRCatatan'},
            { text: 'KR',value:'KR'},
            { text: 'BT',value:'BT'},  
            { text: 'BDR',value:'BDR'},            
            { text: 'BDRLain',value:'BDRLain'},
            { text: 'JT',value:'JT'},
            { text: 'JTLain',value:'JTLain'},
            { text: 'BA',value:'BA'},
            { text: 'BALain',value:'BALain'},
            { text: 'AM',value:'AM'},
            { text: 'AM2',value:'AM2'},
            { text: 'AMLain',value:'AMLain'},
            { text: 'BE', value:'BE'},
            { text: 'ITT', value:'ITT'},
            { text: 'ITM',value:'ITM'},
            { text: 'ITK',value:'ITK'},
            { text: 'SP1', value:'SP1'},
            { text: 'SP2',value:'SP2'},
            { text: 'SP3', value:'SP3'},  
            { text: 'SPLain',value:'SPLain'},
            { text: 'KS',value:'KS'},
            { text: 'TKS',value:'TKS'},
            { text: 'SKS',value:'SKS1'},
           // { text: 'SKS2',value:'SKS2'},
            { text: 'SKSLain',value:'SKSLain'},
           //{ text: 'RRK',value:'RRK'},
          
        ],
       ///////////link untuk ke page/////////////////////
      breadcrumbs: [
       {
          text: 'Status Pengisian',
          disabled: false,
          href: 'ringkasanMaklumatIR',
        },
        {
          text: 'JRF3',
          disabled: true,
          href: "JRF3",
        },
      ],
      valid: true,
      name: '',
      nameRules: [
        v => !!v || 'Name is required',
        v => (v && v.length <= 10) || 'Name must be less than 10 characters',
      ],
      email: '',
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
      ],
      select: null,
      checkbox: false,
    }),
    methods: {
      
      limitDigits(event) {
        const value = event.target.value;
        if (value.length >= 8) {
            event.preventDefault();
        }
      },
    //   formatNumber(value) {
    //    return value.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    // },
    //   stripCommas(value) {
    //     return value.replace(/,/g, '');
    //   },
    formatNumber(value) {
    // Treat 0 as a special case to display 0 in the data table
        if (value === 0) {
            return '0';
        } else if (value === null) {
            return ''; // Treat null values as empty strings for consistency
        } else if (typeof value !== 'string') {
           // value = String(value); // Convert non-string values to string
            value = value.toString();
        }
        // Check if value is empty or not
        if (value.trim() === '') {
            return '';
        }
        // Perform the replace operation to format the number with commas
        return value.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        },

        // stripCommas(value) {
        //   return value.replace(/,/g, '');
        // },
        stripCommas(value) {
        // Check if value is a string before replacing commas
        if (typeof value !== 'string') {
            return value; // Return value unchanged if it's not a string
        }
        return value.replace(/,/g, '');
        },
      limitDigits2(event) {
        const value = event.target.value;
        if (value.length >= 2) {
            event.preventDefault();
        }
      },
   
      S172_AM1(){
        if(this.AM.id == this.AM2.id){
        this.AM = { id: 0 };
        }
      },

      S172_AM2(){
        if(this.AM2.id == this.AM.id){
        this.AM2 = { id: 0 };
        }
      },

      S175_SP1(){

        if (this.SP1.id !=0  && this.SP1.id == this.SP2.id){
        this.SP1 = { id: 0 };
        }
        if (this.SP1.id !=0  && this.SP1.id == this.SP3.id){
        this.SP1 = { id: 0 };
        }
        if (this.SP1.id ==0 ){
        this.SP1 = { id: 0 };
        }
      },

      S175_SP2(){
  
        if(this.SP2.id !=0  && this.SP2.id == this.SP1.id ){
        this.SP2 = { id: 0 };
        }
        if(this.SP2.id !=0  &&  this.SP2.id == this.SP3.id){
        this.SP2 = { id: 0 };
        }

    },
      
      S175_SP3(){

        if(this.SP3.id !=0  && this.SP3.id == this.SP2.id ){
        this.SP3 = { id: 0 };
        }
        if(this.SP3.id !=0  && this.SP3.id == this.SP1.id){
        this.SP3 = { id: 0 };
        }
      },

      validate () {
        this.$refs.form.validate()
      },
      reset() {
        this.$refs.form.reset();
      },
      resetValidation () {
        this.$refs.form.resetValidation()
      },


      async simpan (){
        
        await this.semakan();

        if (this.$refs.form.validate()){
            this.dialog =  true;
            setTimeout(() => (this.dialog = false), 2000)
      
            try {

                          //const res = await axios.post(`${process.env.VUE_APP_API_URL}/JR5/HK1`, {
                          const res = await axios.post(`${process.env.VUE_APP_API_URL}/JRF3/JRF3`, {
                          HID: this.HID,
                          JR: this.JRR.id,
                          JRLain: this.JRLain,
                          JMR: this.JMR.id,
                          JMRLain: this.JMRLain,
                          PL: this.PL.id,
                          HR: this.HR === null ? '0' : this.stripCommas(this.HR),
                          PR: this.PR.id,
                          PRCatatan: this.PRCatatan,
                          KR:this.KR.id,
                          BT: this.BT,
                          BDR: this.BDR.id,
                          BDRLain: this.BDRLain,
                          JT: this.JT.id,
                          JTLain: this.JTLain,
                          BA: this.BA.id,
                          BALain: this.BALain,
                          AM: this.AM.id,
                          AM2: this.AM2.id,
                          AMLain: this.AMLain,
                          BE: this.BE.id,
                          SP1: this.SP1.id,
                          SP2: this.SP2.id,
                          SP3: this.SP3.id,
                          SPLain: this.SPLain,
                          KS: this.KS.id,
                          TKS: this.TKS.id,
                          SKS1: this.SKS1.id,
                          //SKS2: this.SKS2.id,
                          SKSLain: this.SKSLain,
                          ITT: this.ITT.id,
                          ITM: this.ITM.id,
                          ITK: this.ITK.id,
                          //RRK: this.RRK.id,
                          
                                    
                        })
                          this.res = res.data
                          this.successMessage = 'Data Disimpan!';
                          this.getData();
                          this.successDialog = true;
                          setTimeout(() => (this.successDialog = false), 2000);
                          this.reset();                
                          window.scrollTo(0, 0);
                          //setTimeout(() => (this.goTo()), 1000);
                          
                      } catch (error) {
                        //console.log(error)
                        this.errorDialog = true;
                        setTimeout(() => (this.errorDialog = false), 2000);
                        //this.errMessage = 'Simpan : '+error;
                        //this.errMessage = 'Sila semak pengisian!';
                        this.errMessage = 'Berjaya disimpan!';
                      }
                  }else{
                      window.scrollTo(0, 0);
                      this.errorDialog = true;
                      setTimeout(() => (this.errorDialog = false), 2000);
                      //this.errMessage = 'Please fill in the field!';
                      this.errMessage = 'Sila semak pengisian!';
                  }
      },
    
      async kemaskiniJRF() {
        await this.semakan2();  
        this.dialog =  true;
        setTimeout(() => (this.dialog = false), 2000)
      
        try {
                  const res = await axios.post(
                    `${process.env.VUE_APP_API_URL}/JRF3/kemaskiniJRF`,
                    {
                          HID: this.HID,
                          JR: this.JRR.id,
                          JRLain: this.JRLain,
                          JMR: this.JMR.id,
                          JMRLain: this.JMRLain,
                          PL: this.PL.id,
                          HR:this.HR,
                          PR: this.PR.id,
                          PRCatatan: this.PRCatatan,
                          KR:this.KR.id,
                          BT: this.BT,
                          BDR: this.BDR.id,
                          BDRLain: this.BDRLain,
                          JT: this.JT.id,
                          JTLain: this.JTLain,
                          BA: this.BA.id,
                          BALain: this.BALain,
                          AM: this.AM.id,
                          AM2: this.AM2.id,
                          AMLain: this.AMLain,
                          BE: this.BE.id,
                          SP1: this.SP1.id,
                          SP2: this.SP2.id,
                          SP3: this.SP3.id,
                          SPLain: this.SPLain,
                          KS: this.KS.id,
                          TKS: this.TKS.id,
                          SKS1: this.SKS1.id,
                         // SKS2: this.SKS2.id,
                          SKSLain: this.SKSLain,
                          ITT: this.ITT.id,
                          ITM: this.ITM.id,
                          ITK: this.ITK.id,
                          //RRK: this.RRK.id,
                    })
                          this.res = res.data;
                          this.butangKemaskini = false;
                          this.successDialog = true;
                          this.disabledInput = true,
                          this.getData()
                          // setTimeout(() => (this.successDialog = false), 2000);
                          this.successMessage = 'Data Berjaya Dikemaskini!';
                          this.reset();
                          setTimeout(() => (this.goTo()), 1000)
                          
                      } 
                        catch (error) {
                        //console.log(error)
                        this.errorDialog = true;
                      setTimeout(() => (this.errorDialog = false), 2000);
                      //this.errMessage = 'Please fill in the field!';
                      this.errMessage = 'Sila semak pengisian!';
                      }
      
    },


    async deleteJRF(val){

        if(val == 0){
          this.popUpALert = true; 
        }
        else if(val == 1){
          
                  try {
                      ///////////tunjukkan alert padam////////////
                      this.popUpALert = false;
                        ////send delete to API///////
                      if (this.$refs.form.validate()){
                        const res = await axios.post(`${process.env.VUE_APP_API_URL}/JRF3/padamJRF`, {
                        HID:  this.HID,
                        JR: this.JRR.id,
                        JRLain: this.JRLain,
                        JMR: this.JMR.id,
                        JMRLain: this.JMRLain,
                        PL: this.PL.id,
                        HR:this.HR,
                        PR: this.PR.id,
                        PRCatatan: this.PRCatatan,
                        KR:this.KR.id,
                        BT: this.BT,
                        BDR: this.BDR.id,
                        BDRLain: this.BDRLain,
                        JT: this.JT.id,
                        JTLain: this.JTLain,
                        BA: this.BA.id,
                        BALain: this.BALain,
                        AM: this.AM.id,
                        AM2: this.AM2.id,
                        AMLain: this.AMLain,
                        BE: this.BE.id,
                        SP1: this.SP1.id,
                        SP2: this.SP2.id,
                        SP3: this.SP3.id,
                        SPLain: this.SPLain,
                        KS: this.KS.id,
                        TKS: this.TKS.id,
                        SKS1: this.SKS1.id,
                        //: this.SKS2.id,
                        SKSLain: this.SKSLain,
                        ITT: this.ITT.id,
                        ITM: this.ITM.id,
                        ITK: this.ITK.id,
                        //RRK: this.RRK.id,
                      })
                        this.butangDelete = false;
                        this.res = res.data
                        this.successDialog = true;
                        setTimeout(() => (this.successDialog = false), 2000);
                        this.successMessage = 'Data Deleted!'
                        this.reset();
                        this.getData(); 
                      }else{
                        this.errorDialog = true;
                        setTimeout(() => (this.errorDialog = false), 2000);
                        this.errMessage = "Please Fill In the field"
                      }
                      
                    } catch (error) {
                      //console.log(error)
                      this.errorDialog = true;
                      setTimeout(() => (this.errorDialog = false), 2000);
                      this.errMessage = 'Padam : '+error;
                    }
                }
                else if(val == 2){
                  this.popUpALert = false;
                }
          
      },
    
      async getDataINCS22_1(){
      
        try {
            const res = await axios.get(`${process.env.VUE_APP_API_URL}/JRF3/getDataINCS22_1?HID=`+this.HID+`&NOAIR=`+this.NOAIR,{
      
            })
            var dataz = res.data.data
            this.JR = Number(dataz[0].INCS22_1);
            console.log(this.JR)
           

          } catch (error) {
            //console.log(error)
            this.errorDialog = true;
            setTimeout(() => (this.errorDialog = false), 4000);
            //this.errMessage = 'getData : '+ error;
            this.errMessage = "Sila jawab soalan S76 Jenis Rumah di HK8 terlebih dahulu!"
          }
      },
      
      async getData() {
      //dapatkan data dari table JRH based on HID
      try {
        const res = await axios.get(
          `${process.env.VUE_APP_API_URL}/JRF3/JRF3?HID=` +
            this.HID +
            `&NOAIR=` +
            this.NOAIR,
          {}
        );
        var dataz = res.data.data;
        this.dataJRF3 = dataz;
      } catch (error) {
        //console.log(error)
        this.errorDialog = true;
        setTimeout(() => (this.errorDialog = false), 2000);
        this.errMessage = "getData : " + error;
      }
    },

      handleClick(row) {
        console.log('Row clicked:', row);
        //alert(this.JR)
         this.successDialog = true;
          this.kemaskiniDialog = true;
          setTimeout(() => (this.kemaskiniDialog = false), 1000);

          this.butangSimpan = false;
          this.butangKemaskini = true;

          
          //this.JR = row.JR;
          this.HR = this.stripCommas(row.HR);
          this.BT = row.BT;
          this.PRCatatan = row.PRCatatan;
          this.JRLain = row.JRLain;
          this.JTLain = row.JTLain;
          this.BDRLain = row.BDRLain;
          this.BALain = row.BALain;
          this.JMRLain = row.JMRLain;
          this.AMLain = row.AMLain;
          this.SPLain = row.SPLain;
          this.SKSLain = row.SKSLain;


          if(row.JR == 1){
            this.JRR = this.JenisRumah[0];
          }
          if(row.JR == 2){
            this.JRR = this.JenisRumah[1];
          }
          if(row.JR == 3){
            this.JRR = this.JenisRumah[2];
          }
          if(row.JR == 4){
            this.JRR = this.JenisRumah[3];
          }
           if(row.JR == 5){
            this.JRR = this.JenisRumah[4];
          }
           if(row.JR == 6){
            this.JRR = this.JenisRumah[5];
          }
          if(row.JR == 7){
            this.JRR = this.JenisRumah[6];
          }
          if(row.JR == 8){
            this.JRR = this.JenisRumah[7];
          }
          if(row.JR == 9){
            this.JRR = this.JenisRumah[8];
          }
           if(row.JR == 10){
            this.JRR = this.JenisRumah[9];
          }
           if(row.JR == 11){
            this.JRR = this.JenisRumah[10];
          }
          if(row.JR == 12){
            this.JRR = this.JenisRumah[11];
          }
          if(row.JR == 13){
            this.JRR = this.JenisRumah[12];
          }
          if(row.JR == 14){
            this.JRR= this.JenisRumah[13];
          }
           if(row.JR == 15){
            this.JRR = this.JenisRumah[14];
          }
           if(row.JR == 16){
            this.JRR= this.JenisRumah[15];
          }
          if(row.JR == 17){
            this.JRR = this.JenisRumah[16];
          }
          if(row.JR == 18 ){
            this.JRR = this.JenisRumah[17];
          }

           //----------------------------------------
      
          if(row.JMR == 1){
            this.JMR = this.JenisMilikanRumah[0];
          }
          if(row.JMR == 2){
            this.JMR = this.JenisMilikanRumah[1];
          }
          if(row.JMR == 3){
            this.JMR = this.JenisMilikanRumah[2];
          }
           if(row.JMR == 4){
            this.JMR = this.JenisMilikanRumah[3];
          }
          if(row.JMR == 5){
            this.JMR = this.JenisMilikanRumah[4];
          }
          if(row.JMR == 6){
            this.JMR = this.JenisMilikanRumah[5];
          }
          //-------------------------------
           if(row.PL == 1){
            this.PL = this.yaTidak[0];
          }
          if(row.PL == 2){
            this.PL = this.yaTidak[1];
          }

          //-------------------------------

          if(row.PR == 1){
            this.PR = this.yaTidakBerkenaan[0];
          }
           if(row.PR == 2){
            this.PR = this.yaTidakBerkenaan[1];
          }
          if(row.PR == 3){
            this.PR = this.yaTidakBerkenaan[2];
          }
       
          //----------------------------------------
            if(row.KR == 1){
            this.KR = this.KisahRumah[0];
          }
          if(row.KR == 2){
            this.KR = this.KisahRumah[1];
          }
          if(row.KR == 3){
            this.KR = this.KisahRumah[2];
          }
          //----------------------------------------

           if(row.BDR == 1){
            this.BDR = this.BinaanDindingRumah[0];
          }
          if(row.BDR == 2){
            this.BDR = this.BinaanDindingRumah[1];
          }
          if(row.BDR == 3){
            this.BDR = this.BinaanDindingRumah[2];
          }
           if(row.BDR == 4){
            this.BDR = this.BinaanDindingRumah[3];
          }
          //----------------------------------------
            if(row.JT == 1){
            this.JT = this.JenisTandas[0];
          }
          if(row.JT == 2){
            this.JT = this.JenisTandas[1];
          }
          if(row.JT == 3){
            this.JT = this.JenisTandas[2];
          }
          //----------------------------------------
         
           if(row.BA == 1){
            this.BA = this.BekalanAir[0];
          }
          if(row.BA == 2){
            this.BA = this.BekalanAir[1];
          }
          if(row.BA == 3){
            this.BA = this.BekalanAir[2];
          }
      
        //----------------------------------------
            if(row.AM == 1){
            this.AM = this.AirMinuman[0];
          }
          if(row.AM == 2){
            this.AM = this.AirMinuman[1];
          }
           if(row.AM == 3){
            this.AM = this.AirMinuman[2];
          } 
          if(row.AM == 4){
            this.AM = this.AirMinuman[3];
          }
          if(row.AM == 0){
            this.AM = this.AirMinuman[4];
          }
           //----------------------------------------

            if(row.AM2 == 1){
            this.AM = this.AirMinuman[0];
            }
            if(row.AM2 == 2){
              this.AM2 = this.AirMinuman[1];
            }
            if(row.AM2 == 3){
              this.AM2 = this.AirMinuman[2];
            }
            if(row.AM2 == 4){
            this.AM2 = this.AirMinuman[3];
          }
          if(row.AM2 == 0){
            this.AM2 = this.AirMinuman[4];
          }

        //----------------------------------------
           if(row.BE == 1){
            this.BE = this.BekalanElektrik[0];
          }
          if(row.BE == 2){
            this.BE = this.BekalanElektrik[1];
          }
          if(row.BE == 3){
            this.BE = this.BekalanElektrik[2];
          }
          if(row.BE == 4){
            this.BE = this.BekalanElektrik[3];
          }
           if(row.BE == 5){
            this.BE = this.BekalanElektrik[4];
          }
         //----------------------------------------
           if(row.SP1 == 1){
            this.SP1 = this.SisaPepejal[0];
          }
          if(row.SP1 == 2){
            this.SP1 = this.SisaPepejal[1];
          }
          if(row.SP1 == 3){
            this.SP1 = this.SisaPepejal[2];
          }
          if(row.SP1 == 4){
            this.SP1 = this.SisaPepejal[3];
          }
           if(row.SP1 == 5){
            this.SP1 = this.SisaPepejal[4];
          }
           if(row.SP1 == 6){
            this.SP1 = this.SisaPepejal[5];
          }
          if(row.SP1 == 7){
            this.SP1 = this.SisaPepejal[6];
          }
          if(row.SP1 == 8){
            this.SP1 = this.SisaPepejal[7];
          }
          if(row.SP1 == 9){
            this.SP1 = this.SisaPepejal[8];
          }
          if(row.SP1 == 0){
            this.SP1 = this.SisaPepejal[9];
          }

        //----------------------------------------

           if(row.SP2 == 1){
            this.SP2 = this.SisaPepejal[0];
          }
          if(row.SP2 == 2){
            this.SP2 = this.SisaPepejal[1];
          }
          if(row.SP2 == 3){
            this.SP2 = this.SisaPepejal[2];
          }
          if(row.SP2 == 4){
            this.SP2 = this.SisaPepejal[3];
          }
           if(row.SP2 == 5){
            this.SP2 = this.SisaPepejal[4];
          }
           if(row.SP2 == 6){
            this.SP2 = this.SisaPepejal[5];
          }
          if(row.SP2 == 7){
            this.SP2 = this.SisaPepejal[6];
          }
          if(row.SP2 == 8){
            this.SP2 = this.SisaPepejal[7];
          }
          if(row.SP2 == 9){
            this.SP2 = this.SisaPepejal[8];
          }
           if(row.SP2 == 0){
            this.SP2 = this.SisaPepejal[9];
          }

           //----------------------------------------

           if(row.SP3 == 1){
            this.SP3 = this.SisaPepejal[0];
          }
          if(row.SP3 == 2){
            this.SP3 = this.SisaPepejal[1];
          }
          if(row.SP3 == 3){
            this.SP3 = this.SisaPepejal[2];
          }
          if(row.SP3 == 4){
            this.SP3 = this.SisaPepejal[3];
          }
           if(row.SP3 == 5){
            this.SP3 = this.SisaPepejal[4];
          }
           if(row.SP3 == 6){
            this.SP3 = this.SisaPepejal[5];
          }
          if(row.SP3 == 7){
            this.SP3 = this.SisaPepejal[6];
          }
          if(row.SP3 == 8){
            this.SP3 = this.SisaPepejal[7];
          }
          if(row.SP3 == 9){
            this.SP3 = this.SisaPepejal[8];
          }
           if(row.SP3 == 0){
            this.SP3 = this.SisaPepejal[9];
          }
        
        //----------------------------------------
            if(row.KS == 1){
            this.KS = this.KutipanSampah[0];
          }
          if(row.KS == 2){
            this.KS = this.KutipanSampah[1];
          }
           if(row.KS == 3){
            this.KS = this.KutipanSampah[2];
          }
        //----------------------------------------

           if(row.TKS == 1){
            this.TKS = this.TahapKutipanSampah[0];
          }
          if(row.TKS == 2){
            this.TKS = this.TahapKutipanSampah[1];
          }
          if(row.TKS == 3){
            this.TKS = this.TahapKutipanSampah[2];
          }
           if(row.TKS == 4){
            this.TKS = this.TahapKutipanSampah[3];
          }

          if(row.SKS1 == 1){
            this.SKS1 = this.SebabKutipanSampah[0];
          }
          if(row.SKS1 == 2){
            this.SKS1 = this.SebabKutipanSampah[1];
          }
          if(row.SKS1 == 3){
            this.SKS1 = this.SebabKutipanSampah[2];
          }
           if(row.SKS1 == 4){
            this.SKS1 = this.SebabKutipanSampah[3];
          }
          if(row.SKS1 == 5){
            this.SKS1 = this.SebabKutipanSampah[4];
          }
          //----------------------------------------

          if(row.ITT == 1){
            this.ITT = this.yaTidak[0];
          }
          if(row.ITT == 2){
            this.ITT = this.yaTidak[1];
          }

          if(row.ITM == 1){
            this.ITM = this.yaTidak[0];
          }
          if(row.ITM == 2){
            this.ITM = this.yaTidak[1];
          }

          if(row.ITK == 1){
            this.ITK = this.yaTidak[0];
          }
          if(row.ITK == 2){
            this.ITK = this.yaTidak[1];
          }
      },

       goTo(option){
 
        if(option == "1"){
        this.$router.push({name: "ringkasanMaklumatIR"});
      } 
        if(option == "2"){
        this.$router.push({ name: "JRG" });
        }
      },
      semakan(){
        if(this.AM.id != 4 && this.AM2.id != 4 ){
            this.AMLain = "-";
          }
  
        if(this.SP1.id != 9 && this.SP2.id != 9 && this.SP3.id != 9){
            this.SPLain = "-";
          }
},
  semakan2(){
    if(this.AM.id != 4 && this.AM2.id != 4 ){
            this.AMLain = "-";
          }

    if(this.SP1.id != 9 && this.SP2.id != 9 && this.SP3.id != 9){
            this.SPLain = "-";
          }        
},  
   },    
    watch:{

    JR(val){
      //alert(val)
      if(val.id == 0 || val.id != null){
          this.showBorang = true;
          this.JRR = this.JenisRumah[val-1]
      }else{
          this.showBorang = true;
          this.JRR = this.JenisRumah[val-1]
      }
    },

    
    JMR(val){
          if(val.id == 6){
            this.showS160 = true;
          }else{
            this.showS160 = false;
            this.JMRLain = '0';
      }
    },
    
    PR(val){
          if(val.id == 3){
            this.showS163C = true;
          }else{
            this.showS163C = false;
            this.PRCatatan = '-';
      }
    },

    BDR(val){
          if(val.id == 4){
            this.showS167 = true;
            
          }else{
            this.showS167 = false;
            this.BDRLain = '0';
      }
    },
    
    JT(val){
          if(val.id == 3){
            this.showS169 = true;
          }else{
            this.showS169 = false;
            this.JTLain = '0';
          }
    },

    BA(val){

          if(val.id == 3){
            this.showS171 = true;
            
          }else{
            this.showS171 = false;
            this.BALain = '0';
          }
    },

    AM(val){
   
          if(val.id == 4){
            this.showS173A = true;
          }
          else{
      this.showS173A = false;

     
    }
   },
    
  
    AM2(val){
    
          if(val.id == 4){
            this.showS173B = true;
          }
          else{
      this.showS173B = false;
     
    }
   },
    

    KS(val){

          if(val.id != 3){
            this.showS178 = true;
          }
          else{
             this.showS178 = false;
             this.showS179 = false;
             this.showS180 = false;
             this.TKS = { id:0 };
             this.SKS1 = { id:0 };
           //  this.SKS2 = { id:0 };
             this.SKSLain = '0';
          }
    },
    
    TKS(val){

          if(val.id == 1 || val.id == 2){
            this.showS179 = true;
          }if (val.id == 3 || val.id == 4){
            this.showS179 = false;
            this.showS180 = false;
             this.SKS1 = { id:0 };
           //  this.SKS2 = { id:0 };
             this.SKSLain = '0';
          }          
    },

    SP1(val){
         
          if(val.id == 9){
            this.showS176A = true;            
          }
    else{
      this.showS176A= false;
    }
   },
    
    SP2(val){
  
      if(val.id == 9){
            this.showS176B = true;            
          }
          else{
      this.showS176B = false;
    }
   },

    SP3(val){
     
      if(val.id == 9){
            this.showS176C = true;            
          }
          else{
      this.showS176C = false;
    }
   },

    SKS1(val){

          if(val.id == 5){
            this.showS180 = true;
           
          }else{
            this.showS180 = false;
             this.SKSLain = '0' ;
          }
    },
    
   // SKS2(val){

         // if(this.SKS2.id == 5){
          //  this.showS180 = true;
          
         // }else{
           // this.showS180 = false;
           // this.SKSLain = 0;
         // }
     // },      

    // PL(val){
//
       // if(val.id == 1 ||  val.id == null ){
        //this.showS162 = true;
      //  }

       // else{
      //  this.showS162 = false;
      //  this.HR ={ id:0 };
       // this.PR = { id:3 };
      //  this.PRCatatan = '-';
     // }
//}, 
  },    
  
};
</script>


<style>
#app {
  background: url('~@/assets/HIES.jpg')
  no-repeat center center fixed !important;
  background-size: cover;
}

</style>
